import { ref, onMounted, onUnmounted } from 'vue';
import { MEDIA_SIZES, MEDIA_TYPES } from './constants'; // Adjust the path as needed

export function useMediaType() {
  const mediaType = ref('');

  const updateMediaType = () => {
    const width = window.innerWidth;
    
    switch (true) {
      case (width < MEDIA_SIZES.MOBILE):
        mediaType.value = MEDIA_TYPES.MOBILE;
        break;
      case (width < MEDIA_SIZES.MOBILE_LARGE):
        mediaType.value = MEDIA_TYPES.MOBILE_LARGE;
        break;
      case (width < MEDIA_SIZES.TABLET):
        mediaType.value = MEDIA_TYPES.TABLET;
        break;
      case (width < MEDIA_SIZES.TABLET_LARGE):
        mediaType.value = MEDIA_TYPES.TABLET_LARGE;
        break;
      case (width < MEDIA_SIZES.TABLET_EXTRA_LARGE):
        mediaType.value = MEDIA_TYPES.TABLET_EXTRA_LARGE;
        break;
      case (width < MEDIA_SIZES.DESKTOP):
        mediaType.value = MEDIA_TYPES.DESKTOP;
        break;
      default:
        mediaType.value = MEDIA_TYPES.DESKTOP_LARGE;
        break;
    }
  };

  onMounted(() => {
    updateMediaType();
    window.addEventListener('resize', updateMediaType);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', updateMediaType);
  });

  return mediaType;
}
